export default __webpack_public_path__ + "img/ffda309c4ba97e244b256d723cb62b6e.svg";